<template>
  <v-card class="login-form">
    <v-card-title>Регистрация</v-card-title>
    <v-card-subtitle>Зарегистрировать нового пользователя</v-card-subtitle>
    <v-card-text>
      <v-text-field label="Логин"
                    v-model="login"
                    :error="loginError"
                    :error-messages="loginErrorMessage"/>
      <v-text-field label="Адрес электронной почты"
                    v-model="email"
                    :error="emailError"
                    :error-messages="emailErrorMessage"/>
      <v-text-field label="Пароль"
                    :append-icon="passwordStyle ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passwordStyle ? 'password' : 'text'"
                    name="input-10-1"
                    hint="At least 8 characters"
                    counter
                    :error="passwordError"
                    :error-messages="passwordErrorMessage"
                    @click:append="passwordStyle = !passwordStyle"
                    v-model="password"/>
    </v-card-text>
    <v-card-actions>
      <v-row align="center"
             justify="end">
        <v-btn text x-small @click="$router.push({ name: 'Login' })">Войти</v-btn>
        <v-btn text x-small>Вспомнить пароль</v-btn>
        <v-btn @click="tryRegister" :color="buttonColor"
               :loading="isTryingToRegister"
        >Зарегистрироваться</v-btn>
        <v-btn>Очитстить</v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  REGISTER_ACTION,
  CLEAR_REGISTER_STATE_ACTION,
} from '../store/actions/auth-actions';
import {
  PENDING,
  SUCCESS,
  FAILED,
} from '../store/consts';

export default {
  name: 'LoginView',
  data: () => ({
    login: '',
    loginErrorMessages: [],
    password: '',
    email: '',
    passwordStyle: true,
  }),
  mounted() {
    this.$store.dispatch(CLEAR_REGISTER_STATE_ACTION);
  },
  watch: {
    loginState(newState) {
      console.log(newState);
      console.log(newState.lengthIsOk === false);
      console.log((newState.occupied === true));
    },
    overallState(newState) {
      if (newState === SUCCESS) {
        setTimeout(() => {
          this.$router.push({ name: 'login' });
        }, 1000);
      }
    },
  },
  computed: {
    loginState() {
      return this.$store.getters.loginRegistrationState;
    },
    emailState() {
      return this.$store.getters.emailRegistrationState;
    },
    passwordState() {
      return this.$store.getters.passwordRegistrationState;
    },
    overallState() {
      return this.$store.getters.registrationState;
    },
    loginError() {
      return (this.loginState.checked === true) && (
        (this.loginState.lengthIsOk === false) || (this.loginState.occupied === true)
      );
    },
    emailError() {
      return (this.emailState.checked === true) && (
        (this.emailState.lengthIsOk === false) || (this.loginState.occupied === true)
        || (this.emailState.valid === false)
      );
    },
    passwordError() {
      return (this.passwordState.checked === true) && (this.passwordState.lengthIsOk === false);
    },
    loginErrorMessage() {
      if (this.loginState.checked === false) {
        return [];
      }
      let result = '';
      if (this.loginState.lengthIsOk === false) {
        result += 'Имя должно быть длинной от 1 до 50 симолов';
      }
      if (this.loginState.occupied === true) {
        if (result.length > 0) {
          result += ', ';
        }
        result += 'Имя занято';
      }
      return result;
    },
    emailErrorMessage() {
      if (this.emailState.checked === false) {
        return [];
      }
      const result = [];
      if (this.emailState.lengthIsOk === false) {
        result.push('Значение должно быть длинной от 1 до 255 симолов');
      }
      if (this.emailState.occupied === true) {
        result.push('Пользователь с такой почтой уже зарегистрирован');
      }
      if (this.emailState.valid === false) {
        result.push('Необходимо указать правильный адрес электроннйо почты');
      }
      return result.join(', ');
    },
    passwordErrorMessage() {
      if (this.passwordState.checked === false) {
        return [];
      }
      const result = [];
      if (this.passwordState.lengthIsOk === false) {
        result.push('Пароль не может быть короче 8 символов');
      }
      return result.join(', ');
    },
    isTryingToRegister() {
      return this.overallState === PENDING;
    },
    buttonColor() {
      switch (this.overallState) {
        case SUCCESS: {
          return 'success';
        }
        case FAILED: {
          return 'error';
        }
        default: {
          return null;
        }
      }
    },
  },
  methods: {
    tryRegister() {
      this.$store.dispatch(REGISTER_ACTION,
        {
          login: this.login,
          password: this.password,
          email: this.email,
        });
    },
  },
};
</script>

<style scoped lang="sass">
@import "src/styles/base.sass"
.login-form
  width: $auth-window-width
</style>
